const testimonials = [
  {
    name: "Margaret R.",
    location: "Winter Park, FL",
    rating: 5,
    text: "My daughter is a junior at Rollins and was accepted to a semester abroad program in Barcelona with six weeks until departure. We pulled her passport and discovered it had expired two months earlier. Fast Passport Center processed her renewal in five business days. She made her flight to Spain, started her program on time, and had the experience of a lifetime. Their team understood the urgency of academic travel deadlines in a way no other service did.",
    service: "Passport Renewal",
  },
  {
    name: "Dr. James L.",
    location: "Winter Park, FL",
    rating: 5,
    text: "I am a physician at AdventHealth and was invited to present at a medical conference in London with three weeks' notice. My passport had expired during the pandemic and I had never renewed it. I called Fast Passport Center on a Tuesday, shipped my documents overnight from the UPS store on Park Avenue, and had my new passport the following Monday. I presented at the conference and made it back for my clinic schedule. Incredible service.",
    service: "Emergency Passport",
  },
  {
    name: "Catherine B.",
    location: "Baldwin Park, FL",
    rating: 5,
    text: "We booked a Disney cruise to the Bahamas for our family of five — three kids ages 4, 8, and 12. I checked our passports two weeks before sailing and found that all three kids' passports had expired. I completely panicked. Fast Passport Center walked me through the child passport process for all three, I shipped everything overnight from the FedEx on Aloma, and all three passports arrived four days later. We made the cruise with a day to spare. Cannot recommend them enough.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function WinterParkTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Winter Park Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Rollins students, Winter Park professionals, Baldwin Park families, and greater Orlando travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}